import { darken } from 'polished';
import { BsStarFill } from 'react-icons/bs';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

type FavouriteStarProps = {
  $isFavourite?: boolean;
  $hasDarkOutline?: boolean;
};

const FavouriteStar = styled(BsStarFill)<FavouriteStarProps>`
  fill: ${({ $isFavourite }) => ($isFavourite ? COLOR.CHEMISTRY : COLOR.GREY_WHITE)};
  stroke: ${({ $isFavourite, $hasDarkOutline }) =>
    $isFavourite ? darken(0.1, COLOR.CHEMISTRY) : $hasDarkOutline ? COLOR.GUNSMOKE : COLOR.IRON};
  stroke-width: 1px;
  font-size: 14px;
`;

export default FavouriteStar;
